// extracted by mini-css-extract-plugin
export default {"date_input":"styles_date_input__AJ-5J","calendar_icon":"styles_calendar_icon__cnMXU"};